<template>
  <div>
    <div class="head-box">
      <div>
        <el-select
          class="c-m-r-10 c-w-150"
          v-model="formData.timePeriod"
          @change="timePeriodChange"
          placeholder="请选择目标周期"
        >
          <el-option
            v-for="item in options.goalTimePeriod"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-date-picker
          v-if="formData.timePeriod == 'weekly'"
          style="width:150px"
          @change="weekChange"
          v-model="weekValue"
          type="week"
          format="yyyy 第 WW 周"
          :clearable="false"
          placeholder="请选择目标时间范围"
        ></el-date-picker>
        <el-date-picker
          v-else
          style="width:150px"
          @change="getData()"
          v-model="formData.dateScope"
          :type="formData.timePeriod == 'daily' ? 'month' : 'year'"
          :value-format="formData.timePeriod == 'daily' ? 'yyyy-M' : 'yyyy'"
          :clearable="false"
          placeholder="请选择目标时间范围"
        ></el-date-picker>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入姓名/团队/角色"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">新增目标</el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择 个人/组织/角色"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-filter">
        <c-filter></c-filter>
      </div>
      <div class="content-table">
        <el-table
          ref="table"
          height="calc(100% - 50px)"
          :data="fpi.data"
          v-if="refresh"
          highlight-current-row
          border
          @header-dragend="osg.colWidthChange"
        >
          <!-- 动态列 -->
          <c-table :fields="extFields">
            <template slot="measurement">
              <el-table-column
                prop="measurement"
                label="度量指标"
                :formatter="formatMeasurement"
                width="150px"
                show-overflow-tooltip
                fixed
              ></el-table-column>
            </template>
          </c-table>
          <template v-if="colShow">
            <template v-if="formData.timePeriod == 'yearly'">
              <el-table-column :label="formData.dateScope + '年'" min-width="100px">
                <template slot-scope="scope">
                  <el-popover
                    placement="bottom"
                    width="240"
                    @hide="doSave(scope.row, scope.row.goalValue[formData.dateScope])"
                  >
                    <el-input
                      v-model="scope.row.goalValue[formData.dateScope]"
                      placeholder="请输入目标值"
                    ></el-input>
                    <el-button slot="reference" type="text" @click="scope.row.sync = false">
                      <template
                        v-if="
                          scope.row.goalValue[formData.dateScope] ||
                            scope.row.goalValue[formData.dateScope] === 0
                        "
                      >
                        {{ scope.row.goalValue[formData.dateScope] }}
                      </template>
                      <template v-else>
                        设置目标值
                      </template>
                    </el-button>
                  </el-popover>
                </template>
              </el-table-column>
            </template>
            <template v-if="formData.timePeriod == 'quarterly'">
              <el-table-column
                :label="formData.dateScope + '年' + (i + 1) + '季度'"
                v-for="(item, i) in 4"
                :key="i"
                min-width="100px"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="bottom"
                    width="240"
                    @hide="
                      doSave(scope.row, scope.row.goalValue[formData.dateScope + '-' + (i + 1)])
                    "
                  >
                    <el-input
                      v-model="scope.row.goalValue[formData.dateScope + '-' + (i + 1)]"
                      placeholder="请输入目标值"
                    ></el-input>
                    <el-checkbox v-model="scope.row.sync" style="margin:15px 0">
                      应用到其他未设置目标值的时间段
                    </el-checkbox>
                    <el-button slot="reference" type="text" @click="scope.row.sync = false">
                      <template
                        v-if="
                          scope.row.goalValue[formData.dateScope + '-' + (i + 1)] ||
                            scope.row.goalValue[formData.dateScope + '-' + (i + 1)] === 0
                        "
                      >
                        {{ scope.row.goalValue[formData.dateScope + '-' + (i + 1)] }}
                      </template>
                      <template v-else>
                        设置目标值
                      </template>
                    </el-button>
                  </el-popover>
                </template>
              </el-table-column>
            </template>
            <template v-if="formData.timePeriod == 'monthly'">
              <el-table-column
                :label="formData.dateScope + '年' + (i + 1) + '月'"
                v-for="(item, i) in 12"
                :key="i"
                min-width="100px"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="bottom"
                    width="240"
                    @hide="
                      doSave(scope.row, scope.row.goalValue[formData.dateScope + '-' + (i + 1)])
                    "
                  >
                    <el-input
                      v-model="scope.row.goalValue[formData.dateScope + '-' + (i + 1)]"
                      placeholder="请输入目标值"
                    ></el-input>
                    <el-checkbox v-model="scope.row.sync" style="margin:15px 0">
                      应用到其他未设置目标值的时间段
                    </el-checkbox>
                    <el-button slot="reference" type="text" @click="scope.row.sync = false">
                      <template
                        v-if="
                          scope.row.goalValue[formData.dateScope + '-' + (i + 1)] ||
                            scope.row.goalValue[formData.dateScope + '-' + (i + 1)] === 0
                        "
                      >
                        {{ scope.row.goalValue[formData.dateScope + '-' + (i + 1)] }}
                      </template>
                      <template v-else>
                        设置目标值
                      </template>
                    </el-button>
                  </el-popover>
                </template>
              </el-table-column>
            </template>
            <template v-if="formData.timePeriod == 'weekly'">
              <el-table-column :label="weekName" min-width="100px">
                <template slot-scope="scope">
                  <el-popover
                    placement="bottom"
                    width="240"
                    @hide="doSave(scope.row, scope.row.goalValue[weekName])"
                  >
                    <el-input
                      v-model="scope.row.goalValue[weekName]"
                      placeholder="请输入目标值"
                    ></el-input>
                    <el-button slot="reference" type="text" @click="scope.row.sync = false">
                      <template
                        v-if="scope.row.goalValue[weekName] || scope.row.goalValue[weekName] === 0"
                      >
                        {{ scope.row.goalValue[weekName] }}
                      </template>
                      <template v-else>
                        设置目标值
                      </template>
                    </el-button>
                  </el-popover>
                </template>
              </el-table-column>
            </template>
            <template v-if="formData.timePeriod == 'daily'">
              <el-table-column
                :label="formData.dateScope + '-' + (i + 1)"
                v-for="(item, i) in new Date(
                  Number(formData.dateScope.split('-')[0]),
                  Number(formData.dateScope.split('-')[1]),
                  0
                ).getDate()"
                :key="i"
                min-width="100px"
              >
                <template slot-scope="scope">
                  <el-popover
                    placement="bottom"
                    width="240"
                    @hide="
                      doSave(scope.row, scope.row.goalValue[formData.dateScope + '-' + (i + 1)])
                    "
                  >
                    <el-input
                      v-model="scope.row.goalValue[formData.dateScope + '-' + (i + 1)]"
                      placeholder="请输入目标值"
                    ></el-input>
                    <el-checkbox v-model="scope.row.sync" style="margin:15px 0">
                      应用到其他未设置目标值的时间段
                    </el-checkbox>
                    <el-button slot="reference" type="text" @click="scope.row.sync = false">
                      <template
                        v-if="
                          scope.row.goalValue[formData.dateScope + '-' + (i + 1)] ||
                            scope.row.goalValue[formData.dateScope + '-' + (i + 1)] === 0
                        "
                      >
                        {{ scope.row.goalValue[formData.dateScope + '-' + (i + 1)] }}
                      </template>
                      <template v-else>
                        设置目标值
                      </template>
                    </el-button>
                  </el-popover>
                </template>
              </el-table-column>
            </template>
          </template>
          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="doEdit(scope.row)" v-if="osg.has('Goals,edit')">
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>
                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doRemove(scope.row._id)">
                    删除
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="目标" :visible.sync="openDetail" destroy-on-close @closed="doInit">
      <c-form
        :formData="formData"
        :fields="extFields"
        :options="options"
        ref="form"
        :upload="upload"
        labelWidth="110px"
        @changeForm="osg.changeForm"
      >
        <template slot="dateScope">
          <el-date-picker
            @change="dateScopeChange"
            v-model="formData.dateScope"
            :type="formData.timePeriod == 'daily' ? 'month' : 'year'"
            :value-format="formData.timePeriod == 'daily' ? 'yyyy-M' : 'yyyy'"
            :disabled="formData._id ? true : false"
          ></el-date-picker>
        </template>
        <template slot="targetType">
          <el-select v-model="formData.targetType" @change="formData.targetIds = []">
            <el-option
              v-for="item in options.goalTargetType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </template>
        <template slot="targetIds">
          <template>
            <el-select
              v-model="formData.targetIds"
              multiple
              filterable
              remote
              clearable
              v-show="formData.targetType == 'user' || !formData.targetType"
              :remote-method="getUsers"
              placeholder="支持输入姓名或手机号搜索"
            >
              <el-option
                v-for="item in options.users"
                :key="item._id"
                :label="item.name"
                :value="item._id"
              ></el-option>
            </el-select>
            <el-cascader
              v-show="formData.targetType == 'org'"
              v-model="formData.targetIds"
              :options="options.orgs"
              :props="{
                multiple: true,
                checkStrictly: true,
                emitPath: false,
                label: 'orgName',
                value: '_id',
                children: 'orgList'
              }"
              clearable
            ></el-cascader>
            <el-select
              v-show="formData.targetType == 'role'"
              v-model="formData.targetIds"
              multiple
              filterable
              clearable
            >
              <el-option
                v-for="item in options.roles"
                :key="item._id"
                :label="item.name"
                :value="item._id"
              ></el-option>
            </el-select>
          </template>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave()">确 定</el-button>
        <el-button
          @click="
            doInit();
            getData();
          "
        >
          取 消
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'Goals',
  data() {
    window.$this = this;
    return {
      name: 'goal',
      refresh: true,
      fpi: {},
      searchValue: '',
      openDetail: false,
      formData: {
        timePeriod: 'yearly',
        dateScope: '',
        targetIds: [],
        exts: {}
      },
      extFields: [],
      extField: {}, //特殊字段类型 如rate值为number类型,checkbox值为数组不能为空
      rules: this.$util.rules,
      options: {
        // codecfg_goalTimePeriod: { codeId: 'goalTimePeriod' }
        users: [],
        orgs: [],
        roles: []
      },
      upload: {
        url: 'http://up-z1.qiniup.com',
        downloadUrl: this.osg.downloadUrl,
        data: {},
        dialogImageUrl: '',
        dialogVisible: false
      },
      colShow: false, //展示目标值列
      weekValue: new Date(),
      weekName: ''
    };
  },
  mounted() {
    this.doInit();
    this.formData.dateScope = new Date().getFullYear() + '';
    this.osg.getFields('goal', () => {
      this.$forceUpdate();
      this.osg.getFpi();
      this.getData();
      this.getUsers();
      this.getOrgs();
      this.getRoles();
    });
  },
  methods: {
    formatMeasurement(row, column, cellValue) {
      return this.osg.codelabel(row.type + 'Measure', cellValue);
    },
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = {
        timePeriod: this.formData.timePeriod,
        dateScope: this.formData.dateScope,
        targetIds: [],
        exts: {}
      };
      if (this.$refs['formData']) {
        this.$refs['formData'].resetFields();
      }
    },
    timePeriodChange() {
      if (this.formData.timePeriod == 'daily') {
        this.formData.dateScope = new Date().getFullYear() + '-' + (new Date().getMonth() + 1);
      } else if (this.formData.timePeriod == 'weekly') {
        this.weekName = this.getWeekName();
      } else {
        this.formData.dateScope = new Date().getFullYear() + '';
      }
      this.getData();
    },
    weekChange(val) {
      this.formData.dateScope = new Date(val).getFullYear() + '';
      this.weekName = this.getWeekName(val);
      this.getData();
    },
    // 获取周的第一天和最后一条
    getWeekName(val) {
      let curr = val ? new Date(val) : new Date();
      let firstday = new Date(curr.setDate(curr.getDate() - curr.getDay()));
      let lastday = new Date(curr.setDate(curr.getDate() - curr.getDay() + 6));
      return (
        this.$util.readableTime(firstday, 'date') + '~' + this.$util.readableTime(lastday, 'date')
      );
    },
    dateScopeChange(val) {
      if (this.formData.timePeriod == 'weekly') {
        // 获取某年第一周的第一天
        let d = new Date(val, 0, 1);
        let day = d.getDay();
        d.setDate(d.getDate() + (day % 6 ? 0 : ++day % 4));
        this.weekValue = d;
        this.weekName = this.getWeekName(d);
      }
    },
    getData() {
      let params = {
        page: this.fpi.page,
        rows: this.fpi.rows,
        'regex:targetName|string#or': this.searchValue,
        'in:state|array-integer#and': '0,1',
        timePeriod: this.formData.timePeriod,
        dateScope: this.formData.dateScope,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      window.$that.getParams(params);
      this.osg.setFpi(params);
      this.osg.ajax('basic/goal/query.do', params, res => {
        res.data.map(item => {
          item.sync = false;
        });
        this.fpi = res;
        this.colShow = true;
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    },
    doNew() {
      this.doInit();
      this.openDetail = true;
    },
    doEdit(row) {
      row = Object.assign({}, row); //避免编辑内容后取消导致显示异常
      this.$util.renderExtField(this.extFields, row);
      // 解析图片字段
      if (row.images) {
        if (this.$util.isJson(row.images)) {
          row.images = JSON.parse(row.images);
        }
      } else {
        row.images = [];
      }

      this.formData = row;
      this.openDetail = true;
    },
    doSave(row, goalValue) {
      let params = row || this.formData;
      if (row && row.sync) {
        switch (row.timePeriod) {
          // case 'yearly':
          //   if (!row.goalValue[row.dateScope]) {
          //     row.goalValue[row.dateScope] = goalValue;
          //   }
          //   break;
          case 'quarterly':
            for (let i = 1; i <= 4; i++) {
              let key = row.dateScope + '-' + i;
              if (!row.goalValue[key]) {
                row.goalValue[key] = goalValue;
              }
            }
            break;
          case 'monthly':
            for (let i = 1; i <= 12; i++) {
              let key = row.dateScope + '-' + i;
              if (!row.goalValue[key]) {
                row.goalValue[key] = goalValue;
              }
            }
            break;
          case 'weekly':
            break;
          case 'daily':
            var num = new Date(
              Number(row.dateScope.split('-')[0]),
              Number(row.dateScope.split('-')[1]),
              0
            ).getDate();
            for (let i = 1; i <= num; i++) {
              let key = row.dateScope + '-' + i;
              if (!row.goalValue[key]) {
                row.goalValue[key] = goalValue;
              }
            }
            break;
        }
      }
      if (row || this.osg.validate()) {
        this.osg.ajax('basic/goal/upsert.do', params, () => {
          this.doInit();
          this.getData();
          this.osg.toast('保存成功！');
        });
      }
    },
    doEnable(id) {
      this.osg.ajax('basic/goal/valid.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doDisable(id) {
      this.osg.ajax('basic/goal/invalid.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    doRemove(id) {
      this.osg.confirm('是否确认删除？', () => {
        this.osg.ajax('basic/goal/remove.do', { id }, () => {
          this.osg.toast('删除成功');
          this.getData();
        });
      });
    },
    getUsers(searchValue) {
      this.osg.ajax(
        'user/query.do',
        {
          page: 1,
          rows: 20,
          'is:state|integer#and': 1,
          'regex:name|string#or': searchValue,
          'regex:phone|string#or': searchValue,
          sortField: 'createTime',
          sortOrder: 'desc'
        },
        res => {
          this.options.users = res.data;
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    },
    getOrgs() {
      this.osg.ajax(
        'org/query.do',
        {
          // notFilterOrgId: '1'
        },
        res => {
          res.data.orgName = '全部';
          this.options.orgs = [res.data];
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    },
    getRoles() {
      this.osg.ajax(
        'role/query.do',
        { _all: '1', 'is:state|integer#and': 1 },
        res => {
          this.options.roles = res.data;
          this.$forceUpdate();
        },
        {
          noload: true
        }
      );
    }
  }
};
</script>
<style>
.c-w-150 .el-input {
  width: 150px !important;
}
</style>
